export enum DepartmentsParams {
  DepartmentId = 'departmentId',
}
